
import React from 'react';
import { func, number } from 'prop-types';
import { css } from 'aphrodite';

import styles from '../styles';

import Translatable from '../../../../../../../components/Translatable';

export default function ListItemPlus({ i, onClick }) {
    return (
        <li
            className={css(styles.dropdownItem)}
            data-value={`${i}`}
            onClick={onClick}
        >
            <div className={css(styles.textContainer)}>
                <div className={css(styles.filtersText)}>
                    <Translatable
                        content={{
                            transKey: 'common.people_count',
                            count: i,
                            replacements: {
                                number: i
                            }
                        }}
                    />
                </div>
            </div>
        </li>
    );
}

ListItemPlus.propTypes = {
    i: number,
    onClick: func
};



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/GuestInput/GuestPanel/ListItemPlus/ListItemPlus.jsx